// Helper utilities to encode/decode award moreinfo field

function parseMoreInfo(moreinfoStr) {
  const result = { grade11: "", grade12: "", moreInfo: "" };
  if (!moreinfoStr) return result;
  const lines = moreinfoStr.split("\n");
  const rest = [];
  lines.forEach((line) => {
    const trimmed = line.trim();
    if (trimmed.startsWith("Grade11:")) {
      result.grade11 = trimmed.replace("Grade11:", "").trim();
    } else if (trimmed.startsWith("Grade12:")) {
      result.grade12 = trimmed.replace("Grade12:", "").trim();
    } else {
      rest.push(line);
    }
  });
  result.moreInfo = rest.join("\n").trim();
  return result;
}

function buildMoreInfo({ grade11, grade12, moreInfo }) {
  const g11 = grade11 ? grade11.toString().trim() : "";
  const g12 = grade12 ? grade12.toString().trim() : "";
  const additional = moreInfo ? moreInfo.toString().trim() : "";
  const parts = [];
  if (g11) parts.push(`Grade11: ${g11}`);
  if (g12) parts.push(`Grade12: ${g12}`);
  if (additional) {
    if (parts.length) parts.push("");
    parts.push(additional);
  }
  return parts.join("\n");
}

// Provide CommonJS exports for Node scripts
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    parseMoreInfo,
    buildMoreInfo,
  };
}
